import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["style", "className", "flow", "wrap", "alignItemsX", "alignItemsY", "alignY", "gapX", "gapY", "innerRef"];
import React from 'react';
import pt from 'prop-types';
import { Box, BreakpointContext, breakpointPropSwitch } from '../';
import { appendHtmlClass, extendProps, responsivePropType } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var FLEX_GAP = getConfig('FLEX_GAP');
var FLEX_GAP_DEFAULT = getConfig('FLEX_GAP_DEFAULT');
var FLEX_GAP_PREFIX = getConfig('FLEX_GAP_PREFIX');
var Flex = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Flex, _React$Component);
  function Flex() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.DEFAULT_CLASS = 'flex';
    return _this;
  }
  var _proto = Flex.prototype;
  _proto.getResponsiveValue = function getResponsiveValue(options) {
    return breakpointPropSwitch(options, this.context);
  };
  _proto.getEnumStyle = function getEnumStyle(prop, name) {
    var _ref;
    if (!prop) return {};
    var value = this.getResponsiveValue(prop);
    return _ref = {}, _ref[name] = value, _ref;
  };
  _proto.getStyle = function getStyle(style, flow, wrap, alignItemsX, alignItemsY, alignY) {
    return Object.assign(typeof style == 'object' ? style : {}, this.getEnumStyle(alignItemsX, 'justifyContent'), this.getEnumStyle(alignItemsY, 'alignItems'), this.getEnumStyle(alignY, 'alignContent'), this.getEnumStyle(flow, 'flexDirection'), this.getEnumStyle(wrap, 'flexWrap'));
  };
  _proto.getClass = function getClass(className, flow, gapX, gapY) {
    var flowVal = this.getResponsiveValue(flow);
    var isHorizontal = !flowVal || flowVal === 'row' || flowVal === 'row-reverse';
    className = appendHtmlClass(className, this.DEFAULT_CLASS);
    className = appendHtmlClass(className, this.DEFAULT_CLASS + "-" + (isHorizontal ? 'x' : 'y'));
    var gapXVal = this.getResponsiveValue(gapX);
    var gapYVal = this.getResponsiveValue(gapY);
    if (gapXVal && gapXVal !== FLEX_GAP_DEFAULT) className = appendHtmlClass(className, FLEX_GAP_PREFIX + "x-" + gapXVal);
    if (gapYVal && gapYVal !== FLEX_GAP_DEFAULT) className = appendHtmlClass(className, FLEX_GAP_PREFIX + "y-" + gapYVal);
    return className;
  };
  _proto.render = function render() {
    var _this$props = this.props,
      style = _this$props.style,
      className = _this$props.className,
      flow = _this$props.flow,
      wrap = _this$props.wrap,
      alignItemsX = _this$props.alignItemsX,
      alignItemsY = _this$props.alignItemsY,
      alignY = _this$props.alignY,
      gapX = _this$props.gapX,
      gapY = _this$props.gapY,
      innerRef = _this$props.innerRef,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var flexStyle = this.getStyle(style, flow, wrap, alignItemsX, alignItemsY, alignY);
    var flexClass = this.getClass(className, flow, gapX, gapY);
    return /*#__PURE__*/React.createElement(Box, Object.assign({
      style: flexStyle,
      className: flexClass,
      ref: innerRef
    }, rest));
  };
  return Flex;
}(React.Component);
Flex.contextType = BreakpointContext;
Object.assign(Flex, extendProps(Box, ['className', 'id', 'children', 'width', 'height', 'border', 'borderTop', 'borderBottom', 'borderLeft', 'borderRight', 'padding', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'margin', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight', 'mask', 'shadow', 'corner', 'as', 'innerRef'], {
  flow: responsivePropType.bind(this, pt.oneOf(['row', 'row-reverse', 'column', 'column-reverse'])),
  wrap: responsivePropType.bind(this, pt.oneOf(['nowrap', 'wrap', 'wrap-reverse'])),
  alignItemsX: responsivePropType.bind(this, pt.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'])),
  alignItemsY: responsivePropType.bind(this, pt.oneOf(['flex-start', 'flex-end', 'center', 'stretch', 'baseline'])),
  alignY: responsivePropType.bind(this, pt.oneOf(['flex-start', 'flex-end', 'center', 'stretch', 'space-between', 'space-around'])),
  gapX: responsivePropType.bind(this, pt.oneOf(Object.keys(FLEX_GAP))),
  gapY: responsivePropType.bind(this, pt.oneOf(Object.keys(FLEX_GAP)))
}, {
  gapX: 'none',
  gapY: 'none'
}));
export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Flex, Object.assign({
    innerRef: ref
  }, props));
});